export default {
  dialog: {
    add: {
      title: 'Add New User',
      description: 'Enter the details for the new user here. Click save when you\'re done.'
    },
    update: {
      title: 'Update User',
      description: 'Update the user details. Click save when you\'re done.'
    },
    invite: {
      title: 'Invite User',
      description: 'Enter the details for the user invitation here. Click send when you\'re done.'
    }
  },
  fields: {
    name: 'Name',
    email: 'Email',
    role: 'Role',
    branch: 'Branch',
    password: 'Password',
    selectRole: 'Select a role',
    selectBranch: 'Select a branch',
    qboUser: 'QuickBooks User',
    selectQboUser: 'Select QuickBooks User (Optional)',
    noQboUser: 'No QuickBooks User',
    loadingQboUsers: 'Loading QuickBooks users...',
    status: 'Account Status',
    selectStatus: 'Select account status'
  },
  buttons: {
    save: 'Save changes',
    sendInvitation: 'Send Invitation'
  },
  roles: {
    admin: 'Admin',
    noc: 'NOC',
    installer: 'Installer',
    financeAdmin: 'Finance Admin',
    sales: 'Sales',
    creditChecker: 'Credit Checker',
    cashier: 'Cashier'
  },
  columns: {
    cartId: 'Cart ID',
    name: 'Name',
    email: 'Email',
    role: 'Role',
    branch: 'Branch',
    center: 'Center',
    qboUser: 'QuickBooks User',
    noQboUser: 'Not Assigned',
    actions: 'Actions',
    unassigned: 'Unassigned',
    status: 'Status'
  },
  status: {
    enabled: 'Enabled',
    disabled: 'Disabled'
  },
  title: 'Users',
  actions: {
    invite: 'Invite',
    copyId: 'Copy ID',
    delete: 'Delete',
    update: 'Update',
    reInvite: 'Re-invite',
    enable: 'Enable',
    disable: 'Disable'
  },
  notifications: {
    idCopied: {
      title: 'ID Copied',
      description: 'User ID copied to clipboard'
    },
    deleted: {
      title: 'User Deleted',
      description: 'User has been deleted successfully'
    },
    reInvited: {
      title: 'Invitation Resent',
      description: 'Invitation email has been resent successfully'
    },
    enabled: {
      title: 'User Enabled',
      description: 'User account has been enabled successfully'
    },
    disabled: {
      title: 'User Disabled',
      description: 'User account has been disabled successfully'
    },
    error: {
      title: 'Error',
      description: 'An error occurred while performing the action'
    }
  }
} 